import { useQuery } from "@apollo/client";
// Импортируйте GET_MY_PRICING из вашего graphql/api
// import { GET_MY_PRICING } from "../../api/graphql/users";

export function useStorePricing(store: string) {
  // Переопределите путь к вашему GET_MY_PRICING
  // const { data, loading, error } = useQuery(GET_MY_PRICING, { ... });

  // Для мок-версии (если нет GraphQL):
  const data = undefined;
  const loading = false;
  const error = undefined;

  const defaultPrices = {
    GOOGLE_STORE: {
      KEYWORDS: 0.18,
      RATINGS: 0.80,
      REVIEWS: 0.2,
      DIRECT: 0.18,
      VISIT: 0.13,
    },
    APP_STORE: {
      KEYWORDS: 0.28,
      RATINGS: 0.50,
      REVIEWS: 1.0,
      DIRECT: 0.25,
      VISIT: 0.15,
    }
  };

  const normalizeStore = (storeValue: string | null | undefined): 'GOOGLE_STORE' | 'APP_STORE' => {
    if (!storeValue) return 'APP_STORE';
    const upperStore = storeValue.toUpperCase();
    if (upperStore.includes('GOOGLE') || upperStore === 'ANDROID' || upperStore === 'GOOGLE_STORE') {
      return 'GOOGLE_STORE';
    } else {
      return 'APP_STORE';
    }
  };

  const storeKey = normalizeStore(store);
  const fallbackPrices = defaultPrices[storeKey] || defaultPrices['APP_STORE'];

  // Для мок-версии возвращаем только дефолтные значения
  return {
    prices: fallbackPrices,
    loading,
    error,
    visitPrice: fallbackPrices.VISIT,
    keywordPrice: fallbackPrices.KEYWORDS,
    reviewsPrice: fallbackPrices.REVIEWS,
    ratingsPrice: fallbackPrices.RATINGS,
    directPrice: fallbackPrices.DIRECT
  };
} 